<template>
  <div
    style="height: 100vh; position: relative; overflow: hidden;"
    class="d-flex flex-column align-content-between mobile-container"
  >
    <div
      class="nav navbar py-4 font-24 font-weight-bold d-flex justify-content-center"
      :class="{ 'bg-custom': currentStep === 'companies' }"
    >
      <h2 v-if="currentStep !== 'companies'">
        <img src="../assets/logo.svg" style="width:100%; height:100%"/>
      </h2>
      <div
        class="w-50 text-left header"
        v-if="currentStep === 'companies'"
        style="text-align:center!important"
      >
        <span class="text-white title">Bloomキャリア登録 導入企業一覧</span>
      </div>
    </div>

    <!-- Password Setup Component -->
    <PasswordSetup
      v-if="currentStep === 'password'"
      :token="token"
      :userId="user_id"
      :buttonStyle="styleButton"
      @password-submitted="handlePasswordSubmitted"
      @redirect="handleRedirect"
    />

    <!-- Confirmation Page Component -->
    <ConfirmationPage
      v-if="currentStep === 'confirmation'"
      :buttonStyle="styleButton"
      @ok-clicked="handleConfirmationOk"
    />

    <!-- Welcome Message -->
    <div
      class="d-flex justify-content-center body-content"
      v-if="currentStep === 'welcome'"
    >
      <div class="w-50 d-flex align-items-center flex-column">
        <div class="mt-5 mb-5">
          <img
            src="../assets/images/confirm.svg"
            alt="thankyou image"
            class="img-fluid"
          />
        </div>
        <div class="d-flex flex-column">
          <p
            class="font-18 mb-4 font-weight-bold w-100"
            style="text-align:center"
          >
            「Bloomキャリア登録」を利用する大手企業各社へ登録が可能です<br />
            登録可能企業を次の画面でご確認ください
          </p>
        </div>
        <button
          class="btn btn-cstm btn-cstm-primary mt-2 h-auto py-2"
          @click="showCompaniesList"
          :style="styleButton"
        >
          次へ（登録可能企業を表示）
        </button>
      </div>
    </div>

    <!-- Companies List Component -->
    <CompaniesList
      v-if="currentStep === 'companies'"
      :companies="companies"
      :companyData="companyData"
      :token="token"
      :userId="user_id"
      @redirect="handleRedirect"
    />
  </div>
</template>

<script>
import PasswordSetup from './PasswordSetup.vue';
import ConfirmationPage from './ConfirmationPage.vue';
import CompaniesList from './CompaniesList.vue';

export default {
  name: 'VerifyEmail',
  components: {
    PasswordSetup,
    ConfirmationPage,
    CompaniesList
  },
  data() {
    return {
      token: this.$route.params.token,
      user_id: this.$route.params.id,
      companies: [],
      companyData: undefined,
      currentStep: 'password', // 'password', 'confirmation', 'welcome', 'companies'
    };
  },
  computed: {
    styleButton() {
      return {
        background: 'red',
        'border-color': 'red',
      };
    },
  },
  methods: {
    handlePasswordSubmitted(result) {
      console.log(result);
      // Set the auth token first since it's always present
      if (result.data && result.data.access_token) {
        this.$auth.setToken(result.data);
      }
      // Handle the response based on whether companies are returned
      if (result.data && result.data.companies) {
        // Companies are available, show confirmation then companies
        this.companies = result.data.companies;
        this.companyData = result.data.company;
        this.currentStep = 'confirmation';
      } else {
        // No companies, redirect to main page
        this.$router.push('/');
      }
    },
    handleConfirmationOk() {
      if (this.companies.length > 0) {
        this.currentStep = 'companies';
      } else {
        // Redirect to dashboard if no companies
        this.$router.push({ name: 'dashboard' });
      }
    },
    showCompaniesList() {
      this.currentStep = 'companies';
    },
    handleRedirect(route) {
      this.$router.push({ name: route });
    },
    async verify() {
      try {
        if (!this.token || !this.user_id) {
          this.$router.push({ name: 'pageNotFound' });
        } else {
          // Show password field immediately for verification
          this.currentStep = 'password';
        }
      } catch (error) {
        if (error.response && error.response.status === 400) {
          this.$router.push({ name: 'login' });
        }
      }
    },
  },
  created() {
    this.verify();
  },
  metaInfo() {
    let title;
    if (this.currentStep === 'confirmation') {
      title = '認証完了';
    } else if (this.currentStep === 'password') {
      title = 'パスワード設定';
    } else if (this.currentStep === 'welcome') {
      title = '登録完了';
    } else {
      title = 'Bloomキャリア登録導入企業一覧 導入企業一覧';
    }
    return {
      title: `${title} | Bloomキャリア登録`,
    };
  },
};
</script>

<style scoped>
.bg-custom {
  background-color: #076d6c;
}

.navbar-white {
  background-color: #ffffff !important;
  border-bottom: 1px solid #e0e0e0;
}

.font-24 {
  font-size: 24px;
}

.font-18 {
  font-size: 18px;
}

.btn-cstm {
  padding: 15px 20px;
  width: 343px;
  border-radius: 8px;
  height: 55px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 900;
  color: #fff !important;
}

@media only screen and (max-width: 992px) {
  .navbar > div,
  .body-content > div {
    width: 75% !important;
  }
}

@media only screen and (max-width: 576px) {
  .navbar > div,
  .body-content > div {
    width: 100% !important;
    padding-left: 1rem;
    padding-right: 1rem;
  }
}

@media (max-width: 550px) {
  .mobile-container {
    height: 93vh !important;
  }
  .text-white {
    font-size: 20px;
  }
}
</style>
